const data = {
  primaryColor: "#607d8b",
  lightColor: false,
  title: "Reporting API",
  category: "Internal Tools",
  icon: "/images/app-icons/console.png",
  slogan:
    "Monitoring servers, processing and analyzing logs and crashes, analyzing visits",
  shortDescription:
    "Advance API that monitors my servers, APIs, visiting and availability of my ReactJS websites with processing logs and crashes of Android applications and APIs",
  fullDescription:
    "Advance API that monitors my servers, APIs, visiting and availability of my ReactJS websites and processing of my logs and crashes of Android applications",
  usesCases: [],
  properties: [
    "Monitoring health and availability of APIs",
    "Monitoring resource usage and availability of server",
    "Monitoring availability of ReactJS websites",
    "Processing logs from APIs that are sent by Log4j2",
    "Processing logs from Android applications that are sent from ACRA",
    "Processing events of visits that are sent from ReactJS websites",
    "Creating daily reports about APIs, servers, ReactJS websites and Android Applications",
  ],
  services: [],
  android: null,
  frontend: null,
  backend: {
    versioning: {
      releasedOn: new Date(2023, 0, 1),
      currentVersion: "1.0.1",
      updatedOn: new Date(2023, 0, 19),
    },
    techInformation: {
      language: "Java 17",
      framework: "Spring Boot 2.7.1",
      logging: "Log4j2",
      metrics: "Spring Boot Actuator",
      virtualization: "Docker",
      containerOS: "openjdk:17.0.2-slim",
      deployed: "k3s cluster",
      database: null,
      integrations: [],
    },
  },
};

class ReportingApiProjectData {
  get() {
    return data;
  }

  getAsItem() {
    return {
      tag: "reporting-api",
      title: data.title,
      category: data.category,
      icon: data.icon,
      shortDescription: data.shortDescription,
      platform: {
        android: data.android !== null,
        frontend: data.frontend !== null,
        backend: data.backend !== null,
      },
    };
  }

  getIfCategoryIsMatched(categoryName) {
    if (categoryName === data.category) {
      return this.getAsItem();
    }

    return undefined;
  }
}

export default new ReportingApiProjectData();
